import DataTable, { createTheme } from "react-data-table-component";
import { GoChevronDown } from "react-icons/go";
import { Loader } from "rsuite";

import { useConfig } from "../../../context/config-context";

export default function TablePatient({
  className,
  tutoMode,
  patients,
  isLoading,
  limit,
  handleDocument,
  handleLimit,
  handleSort,
  handlePage,
  isMenuOpen,
}) {
  const siteConfig = useConfig();
  const tableConfig = siteConfig.components.table_patient;

  createTheme(
    siteConfig.themes.table.name,
    siteConfig.themes.table.customTheme
  );

  return (
    <div className={`w-full h-full rounded-lg ${className}`}>
      <DataTable
        columns={tableConfig.columns({
          tutoMode,
          handleDocument,
        })}
        className={`rounded-b-xl ${tutoMode ? "!pointer-events-none" : ""}`}
        data={patients.docs}
        noDataComponent={
          <span className="w-full font-semibold text-center">
            {siteConfig.no_data}
          </span>
        }
        customStyles={tableConfig.customStyles(tutoMode, isMenuOpen)}
        conditionalRowStyles={tableConfig.conditionalRowStyles}
        defaultSortFieldId={tableConfig.defaultSortFieldId || 1}
        defaultSortAsc={false}
        sortIcon={<GoChevronDown className="ml-1" color="var(--light)" />}
        striped
        highlightOnHover
        pagination
        theme="solarized"
        paginationPerPage={limit}
        paginationRowsPerPageOptions={[25, 50, 100]}
        progressPending={isLoading}
        progressComponent={<Loader className="w-full text-center" />}
        paginationServer
        paginationDefaultPage={patients.page}
        paginationServerOptions={{
          persistSelectedOnPageChange: true,
          persistSelectedOnSort: true,
        }}
        paginationTotalRows={patients.totalDocs}
        onChangePage={async (page) => await handlePage(page)}
        onChangeRowsPerPage={async (newPerPage) =>
          await handleLimit(newPerPage)
        }
        sortServer
        onSort={async (column, sortDirection) =>
          await handleSort(
            `{"${column.sortfield}":${sortDirection === "desc" ? -1 : 1}${
              column.sortfield === "lastName"
                ? `,"firstName":${sortDirection === "desc" ? -1 : 1}`
                : ""
            }}`
          )
        }
        dense
        paginationComponentOptions={{
          rowsPerPageText: tableConfig.pagination.rowsPerPageText,
          rangeSeparatorText: tableConfig.pagination.rangeSeparatorText,
          noRowsPerPage: false,
          selectAllRowsItem: false,
          selectAllRowsItemText: "All",
        }}
      />
    </div>
  );
}
